var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgWindows = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M27.702 4.18a.8.8 0 0 1 .298.622v10.4H15.2V6.554l11.832-2.537a.8.8 0 0 1 .672.16M13.6 6.898 4.632 8.819A.8.8 0 0 0 4 9.602v5.6h9.6zM4 16.8v7.2a.8.8 0 0 0 .688.791l8.912 1.274V16.8zm11.2 9.494 11.888 1.697A.798.798 0 0 0 28 27.2V16.801H15.2z"
})));
export default SvgWindows;